function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ic-search-result-a",
  d: "M0 0h58.333v70H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M18.667 8.167H35V5.833H18.667zM24.5 65.333h4.667V63H24.5z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ic-search-result-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ic-search-result-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M36.167 44.333H38.5V42h-2.333v2.333zM35 46.667h4.667c.645 0 1.166-.522 1.166-1.167v-4.667c0-.644-.521-1.166-1.166-1.166H35c-.645 0-1.167.522-1.167 1.166V45.5c0 .645.522 1.167 1.167 1.167zM15.167 42H31.5v-2.333H15.167zm4.666 4.667H31.5v-2.334H19.833zm-4.666 0H17.5v-2.334h-2.333zM26.833 31.5h2.334v-4.667h-2.334z",
  mask: "url(#ic-search-result-b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M43.166 60.667v3.5a3.5 3.5 0 0 1-3.5 3.5H14a3.5 3.5 0 0 1-3.5-3.5v-3.5h32.666zm-31.5-9.334c.644 0 1.167-.521 1.167-1.166V37.813c4.775-1.93 7.083-7.364 5.153-12.14a9.324 9.324 0 0 0-7.486-5.76v-7.08h32.666v9.334H28a7.001 7.001 0 0 0 0 14h15.166v22.166H10.5v-7h1.166zM9.333 38.5c.39-.002.78-.03 1.167-.08V49H8.166V38.42c.388.05.777.078 1.167.08zm-7-9.333a7.001 7.001 0 0 1 14 0c0 3.865-3.135 7-7 7a7.006 7.006 0 0 1-7-7zM10.5 5.833a3.5 3.5 0 0 1 3.5-3.5h25.666a3.5 3.5 0 0 1 3.5 3.5V10.5H10.5V5.833zM56 29.167a4.667 4.667 0 0 1-4.667 4.666H28a4.667 4.667 0 0 1 0-9.333h23.333A4.667 4.667 0 0 1 56 29.167zm-47.834 35A5.84 5.84 0 0 0 14 70h25.666a5.84 5.84 0 0 0 5.834-5.833v-28h5.833a7.001 7.001 0 0 0 0-14H45.5V5.833A5.84 5.84 0 0 0 39.666 0H14a5.84 5.84 0 0 0-5.834 5.833v14.08a9.325 9.325 0 0 0-2.333 17.9v12.354c0 .645.523 1.166 1.167 1.166h1.166v12.834z",
  mask: "url(#ic-search-result-b)"
}));

const SvgIcSearchResult = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 70,
    viewBox: "0 0 59 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSearchResult, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-search-result.cb1d757d.svg";
export { ForwardRef as ReactComponent };